"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _bind = _interopRequireDefault(require("classnames/bind"));

var _mobxReact = require("mobx-react");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

require("./Heading.css");

var _styles = {
  "heading": "Heading__heading___1OzoE",
  "h1": "Heading__h1___1JaKu",
  "h2": "Heading__h2___2QB8x",
  "h3": "Heading__h3___39Rrm",
  "h4": "Heading__h4___1YJ-G",
  "h5": "Heading__h5___DrSeK",
  "regular": "Heading__regular___1J8N2",
  "medium": "Heading__medium___BzDaw",
  "italic": "Heading__italic___1hAP7"
};

const styles = _bind.default.bind(_styles);

const Heading = (0, _mobxReact.observer)(({
  className,
  children,
  variant = 'regular',
  tag: Tag = 'h1',
  size,
  text,
  noMargin = false,
  marginBottom,
  color,
  dataTestId,
  ...props
}) => {
  const composed_classname = (0, _bind.default)(styles('heading', variant, Tag), className);
  const override_styles = {
    fontSize: `${size}px`,
    lineHeight: `${size && '1.2em'}`,
    margin: noMargin ? '0 0 0' : '0 0 16px',
    marginBottom: `${marginBottom}px`,
    color: color && color
  };
  return _react.default.createElement(Tag, {
    className: composed_classname,
    style: override_styles,
    "data-size": size,
    "data-testid": dataTestId,
    ...props
  }, children || text);
});
var _default = Heading;
exports.default = _default;